<template>
  <t-default-layout active-nav-id="online-shop-support">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="OnlineShopSupport" :show="show" />
      <form
        ref="form"
        class="t-online-shop-support-detail__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-online-shop-support-detail__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="detail-online-shop-support"
              title="詳細設定"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-online-shop-support-detail__fields">
                <div id="t-online-shop-support-detail-uploading-file" class="t-online-shop-support-detail__row">
                  <div class="t-online-shop-support-detail__col-1">
                    <div class="t-online-shop-support-detail__fields">
                      <m-form-input>
                        <a-upload-field
                          id="t-online-shop-support-detail-upload-image"
                          v-model="onlineShopSupportData.imageFile.file"
                          test-id-text="detail-online-shop-support-image"
                          name="imageFile"
                          class="t-online-shop-support-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                          @change="handleUploadFileChange('imageFile', onlineShopSupportData.imageFile.file)"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-online-shop-support-detail__col-2">
                    <div class="t-online-shop-support-detail__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="onlineShopSupportData.title"
                          data-testid="detail-online-shop-support-title-display"
                          type="text"
                          maxlength="50"
                          maxlength-id="a-apply-text-field__character-count-title"
                          placeholder="タイトル入力"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
                <div class="t-online-shop-support-add__row">
                  <a-text id="t-online-shop-support-add-importantFlag__a-text"> 外部Webサイト</a-text>
                  <m-form-input>
                    <a-apply-text-field
                      id="t-online-shop-support-add__contents-url"
                      v-model="onlineShopSupportData.contentsURL"
                      class="t-online-shop-support-add__contents-url"
                      :disabled="true"
                      data-testid="t-online-shop-support-add-url-input"
                      type="text"
                      maxlength="500"
                      maxlength-id="a-apply-text-field__character-count-contentsURL"
                      placeholder="URL入力"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-online-shop-support-detail__fields">
                <div
                  id="t-online-shop-support-detail-cast-start-date-day__row"
                  class="t-online-shop-support-detail__row"
                >
                  <a-text id="t-online-shop-support-detail-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-online-shop-support-detail-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="onlineShopSupportData.castStartDate"
                      test-id-text="detail-online-shop-support-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div class="t-online-shop-support-detail__row">
                  <a-text id="t-online-shop-support-detail-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-online-shop-support-detail-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="onlineShopSupportData.castEndDate"
                      test-id-text="detail-online-shop-support-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-online-shop-support-detail__fields__pushtype">
                <m-form-input id="t-online-shop-support-detail__fields__pushtype">
                  <a-select-field
                    id="t-online-shop-support-detail__fields__pushtype__a-select-field"
                    v-model="onlineShopSupportData.checkStatus"
                    data-testid="detail-online-shop-support-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="onlineShopSupportData.checkHistories"
                id-text="online-shop-support-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <div id="t-online-shop-support-detail-buttons">
          <div v-show="!isPublished" class="t-online-shop-support-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-online-shop-support-detail-detail-saveBtn"
                data-testid="detail-online-shop-support-edit-button"
                variant="block"
                color="primary"
                :disabled="isEnded || disableButton"
                @click="handleNavigateEdit"
                >編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-online-shop-support-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-online-shop-support-detail-edit-return-unpublished-btn"
                data-testid="detail-online-shop-support-edit-return-unpublished-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleEditReturnUnpublished"
                >未公開に戻す</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-online-shop-support-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-online-shop-support-detail-edit-keep-published-btn"
                data-testid="detail-online-shop-support-edit-keep-published-button"
                variant="block"
                color="primary"
                :disabled="disabledButton || disableButton"
                @click.stop="handleEditKeepPublished"
                >公開のまま編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div class="t-online-shop-support-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-online-shop-support-detail-detail-deleteBtn"
                data-testid="detail-online-shop-support-delete-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleConfirmDelete"
                >削除</a-button
              >
            </m-form-action-buttons>
          </div>
        </div>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="online-shop-bannersCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="online-shop-bannersCreate_resultModal-content" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="t-online-shop-support-remove-modal-close-button"
            data-testid="detail-online-shop-support-modal-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="t-online-shop-support-delete-button"
            data-testid="detail-online-shop-support-modal-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleDelete"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';

export default {
  name: 't-online-shop-support-detail',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    AUploadField,
    ACalendarField,
    AApplyTextField,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      show: this.$route.query.show ?? '1',
      idName: [],
      disableButton: false,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,
      isPublished: false, //公開中かどうかのフラグ
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      // コンテンツデータ
      onlineShopSupportData: {
        title: '', // タイトル
        imageURL: '', // 画像の公開URL
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        position: 0, // 優先フラグ
        castStartDate: '', // 公開開始日
        castEndDate: '', // 公開終了日
        draftFlag: false, // 下書き
        checkStatus: '', // チェックステータス
        contentsURL: '', // URL
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
      },
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      isEnded: false,
      nowDate: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-online-shop-support-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.handleGetOnlineShopSupportInfo(() => {
      const userRole = this.$store.state.user.authInfo;
      const checkStatus = this.onlineShopSupportData.checkStatus;
      if (userRole === 'writer' && checkStatus !== 'draft') {
        this.disableButton = true;
      }
    });
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-online-shop-support-detail-' + i;
    }
  },
  mounted() {},
  methods: {
    handleGetOnlineShopSupportInfo(callback) {
      const id = this.$route.query.id || this.id;
      this.nowDate = utils.currentDateTime();
      if (id) {
        this.postRequest('/online-shop-support/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              this.onlineShopSupportData.title = data?.title || '';
              this.onlineShopSupportData.imageURL = data?.imageURL || '';
              (this.onlineShopSupportData.imageFile = {
                file: e.data.imageURL ? e.data.imageURL : null,
              }),
                (this.onlineShopSupportData.castStartDate = data?.castStartDate || '');
              this.onlineShopSupportData.castEndDate = data?.castEndDate || '';
              this.onlineShopSupportData.draftFlag = data?.draftFlag || false;
              this.onlineShopSupportData.contentsURL = decodeURI(data?.contentsURL) || '';
              this.onlineShopSupportData.checkStatus = data?.checkStatus || '';
              this.onlineShopSupportData.checkHistories = data?.checkHistories || [];
              // 下書きとチェク済み中ではなく、公開終了日時を過ぎている場合、isEndedフラグをtrueにする
              if (this.onlineShopSupportData.checkStatus === 'approved') {
                if (this.onlineShopSupportData.castEndDate && this.onlineShopSupportData.castEndDate < this.nowDate) {
                  this.isEnded = true;
                }
              }
              const nowDate = utils.currentDateTime();
              // 公開中の投稿か確認
              if (
                data &&
                data.checkStatus === 'approved' &&
                data.castStartDate &&
                data.castEndDate &&
                data.castStartDate <= nowDate &&
                nowDate <= data.castEndDate
              ) {
                this.isPublished = true;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('ショップ（お悩み・課題）取得'));
            }
            if (typeof callback === 'function') {
              callback();
            }
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('ショップ（お悩み・課題）取得'));
          });
      }
    },
    async handleEditReturnUnpublished() {
      const data = {
        id: this.$route.query.id,
      };
      await this.postRequest('/online-shop-support/edit-return-unpublished', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'OnlineShopSupport' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('ショップ（お悩み・課題）更新'));
          }
        }
      });
    },
    async handleEditKeepPublished() {
      const data = {
        id: this.$route.query.id,
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/online-shop-support/edit-keep-published', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'OnlineShopSupport' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('ショップ（お悩み・課題）更新'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleNavigateEdit() {
      const id = this.$route.query.id;
      if (id) {
        this.$router.push({ name: 'OnlineShopSupportEdit', query: { id: id, source: 'detail', show: this.show } });
      }
    },
    handleConfirmDelete() {
      this.resultModalVisible = true;
      this.resultModalTitle = 'Info';
      this.resultModalContent = messageContent.confirmDelete(this.onlineShopSupportData.title);
    },
    handleDelete() {
      this.handleCloseModal();
      const data = {
        execUserID: this.$store.state.user.userID,
        documentID: this.$route.query.id,
      };
      this.postRequest('/online-shop-support/delete', data).then(() => {
        this.$router.push({ name: 'OnlineShopSupport', query: { show: this.show } });
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'OnlineShopSupport', query: { show: this.show } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
